import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "MailCompose" */ './lazyIndex');
});
// Delay loaded components
export var FullCompose = createLazyComponent(lazyModule, function (m) { return m.FullCompose; });
export var Compose = createLazyComponent(lazyModule, function (m) { return m.Compose; });
export var Dock = createLazyComponent(lazyModule, function (m) { return m.Dock; });
export var ComposeCommandingBar = createLazyComponent(lazyModule, function (m) { return m.ComposeCommandingBar; });
export var FloatingComposeContainer = createLazyComponent(lazyModule, function (m) { return m.FloatingComposeContainer; });
export var ComposeTab = createLazyComponent(lazyModule, function (m) { return m.ComposeTab; });
//# sourceMappingURL=index.js.map